import React, { useEffect } from "react";
import AllPrawn from "../Prawn/AllPrawn";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const Prawn = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <AllPrawn />
      <Footer />
    </>
  );
};

export default Prawn;
